import { makeAutoObservable } from "mobx";

class StoreReferralFormat {

    paymentOptionSelected = 'onetime'
    shippingOptionSelected = 'delivery'

    constructor() {
        makeAutoObservable(this)
    }
}

export default new StoreReferralFormat()